/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillPaymentInfoVo } from './BillPaymentInfoVo';
import {
    BillPaymentInfoVoFromJSON,
    BillPaymentInfoVoFromJSONTyped,
    BillPaymentInfoVoToJSON,
    BillPaymentInfoVoToJSONTyped,
} from './BillPaymentInfoVo';
import type { BillDetailAdditionalServiceVo } from './BillDetailAdditionalServiceVo';
import {
    BillDetailAdditionalServiceVoFromJSON,
    BillDetailAdditionalServiceVoFromJSONTyped,
    BillDetailAdditionalServiceVoToJSON,
    BillDetailAdditionalServiceVoToJSONTyped,
} from './BillDetailAdditionalServiceVo';
import type { BillDetailCommonVo } from './BillDetailCommonVo';
import {
    BillDetailCommonVoFromJSON,
    BillDetailCommonVoFromJSONTyped,
    BillDetailCommonVoToJSON,
    BillDetailCommonVoToJSONTyped,
} from './BillDetailCommonVo';
import type { BillDetailGoodsVo } from './BillDetailGoodsVo';
import {
    BillDetailGoodsVoFromJSON,
    BillDetailGoodsVoFromJSONTyped,
    BillDetailGoodsVoToJSON,
    BillDetailGoodsVoToJSONTyped,
} from './BillDetailGoodsVo';

/**
 * 
 * @export
 * @interface BillDetailVo
 */
export interface BillDetailVo {
    /**
     * ID
     * @type {number}
     * @memberof BillDetailVo
     */
    id?: number;
    /**
     * 账单类型
     * @type {number}
     * @memberof BillDetailVo
     */
    billType?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof BillDetailVo
     */
    orderCode?: string;
    /**
     * 汇率
     * @type {number}
     * @memberof BillDetailVo
     */
    exchangeRate?: number;
    /**
     * 计算货物运费的单位
     * @type {number}
     * @memberof BillDetailVo
     */
    applyUnit?: number;
    /**
     * 适用货物运费的值
     * @type {number}
     * @memberof BillDetailVo
     */
    applyValue?: number;
    /**
     * 货物收费总金额
     * @type {number}
     * @memberof BillDetailVo
     */
    totalGoodsAmount?: number;
    /**
     * 附加服务总金额
     * @type {number}
     * @memberof BillDetailVo
     */
    totalAdditionalServiceAmount?: number;
    /**
     * 钱包转账总金额
     * @type {number}
     * @memberof BillDetailVo
     */
    totalTransferAmount?: number;
    /**
     * 账单总金额
     * @type {number}
     * @memberof BillDetailVo
     */
    totalAmount?: number;
    /**
     * 卡号
     * @type {string}
     * @memberof BillDetailVo
     */
    cardNumber?: string;
    /**
     * 卡类型
     * @type {number}
     * @memberof BillDetailVo
     */
    cardType?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof BillDetailVo
     */
    currencyCode?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof BillDetailVo
     */
    userId?: number;
    /**
     * 账单名
     * @type {string}
     * @memberof BillDetailVo
     */
    name?: string;
    /**
     * 账单状态
     * @type {number}
     * @memberof BillDetailVo
     */
    status?: number;
    /**
     * 是否可用
     * @type {number}
     * @memberof BillDetailVo
     */
    enable?: number;
    /**
     * 账单编号
     * @type {string}
     * @memberof BillDetailVo
     */
    billCode?: string;
    /**
     * 卡所在银行名称
     * @type {string}
     * @memberof BillDetailVo
     */
    cardBankName?: string;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof BillDetailVo
     */
    cardHolderName?: string;
    /**
     * 备注
     * @type {string}
     * @memberof BillDetailVo
     */
    remark?: string;
    /**
     * 创建账单的管理员ID
     * @type {number}
     * @memberof BillDetailVo
     */
    createStaffId?: number;
    /**
     * 客户商业类型：1-企业，2-个人
     * @type {number}
     * @memberof BillDetailVo
     */
    userBusinessType?: number;
    /**
     * 账单关联实体ID
     * @type {number}
     * @memberof BillDetailVo
     */
    targetId?: number;
    /**
     * 
     * @type {BillDetailVo}
     * @memberof BillDetailVo
     */
    originalBill?: BillDetailVo;
    /**
     * 仓库ID（订单创建账单时归属的仓库；钱包操作类账单为空）
     * @type {number}
     * @memberof BillDetailVo
     */
    warehouseId?: number;
    /**
     * 退款金额
     * @type {number}
     * @memberof BillDetailVo
     */
    returnAmount?: number;
    /**
     * 关联账单编号列表（用当前账单id作为target_id检索billType=28的公共退款账单编号）
     * @type {Array<string>}
     * @memberof BillDetailVo
     */
    relatedBillCodes?: Array<string>;
    /**
     * 创建时间
     * @type {string}
     * @memberof BillDetailVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BillDetailVo
     */
    updateTime?: string;
    /**
     * 货物明细列表
     * @type {Array<BillDetailGoodsVo>}
     * @memberof BillDetailVo
     */
    goodsList?: Array<BillDetailGoodsVo>;
    /**
     * 附加服务明细列表
     * @type {Array<BillDetailAdditionalServiceVo>}
     * @memberof BillDetailVo
     */
    additionalServiceList?: Array<BillDetailAdditionalServiceVo>;
    /**
     * 明细通用记录列表
     * @type {Array<BillDetailCommonVo>}
     * @memberof BillDetailVo
     */
    commonList?: Array<BillDetailCommonVo>;
    /**
     * 
     * @type {BillPaymentInfoVo}
     * @memberof BillDetailVo
     */
    paymentInfo?: BillPaymentInfoVo;
}

/**
 * Check if a given object implements the BillDetailVo interface.
 */
export function instanceOfBillDetailVo(value: object): value is BillDetailVo {
    return true;
}

export function BillDetailVoFromJSON(json: any): BillDetailVo {
    return BillDetailVoFromJSONTyped(json, false);
}

export function BillDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
        'applyUnit': json['applyUnit'] == null ? undefined : json['applyUnit'],
        'applyValue': json['applyValue'] == null ? undefined : json['applyValue'],
        'totalGoodsAmount': json['totalGoodsAmount'] == null ? undefined : json['totalGoodsAmount'],
        'totalAdditionalServiceAmount': json['totalAdditionalServiceAmount'] == null ? undefined : json['totalAdditionalServiceAmount'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'billCode': json['billCode'] == null ? undefined : json['billCode'],
        'cardBankName': json['cardBankName'] == null ? undefined : json['cardBankName'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createStaffId': json['createStaffId'] == null ? undefined : json['createStaffId'],
        'userBusinessType': json['userBusinessType'] == null ? undefined : json['userBusinessType'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'originalBill': json['originalBill'] == null ? undefined : BillDetailVoFromJSON(json['originalBill']),
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'returnAmount': json['returnAmount'] == null ? undefined : json['returnAmount'],
        'relatedBillCodes': json['relatedBillCodes'] == null ? undefined : json['relatedBillCodes'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'goodsList': json['goodsList'] == null ? undefined : ((json['goodsList'] as Array<any>).map(BillDetailGoodsVoFromJSON)),
        'additionalServiceList': json['additionalServiceList'] == null ? undefined : ((json['additionalServiceList'] as Array<any>).map(BillDetailAdditionalServiceVoFromJSON)),
        'commonList': json['commonList'] == null ? undefined : ((json['commonList'] as Array<any>).map(BillDetailCommonVoFromJSON)),
        'paymentInfo': json['paymentInfo'] == null ? undefined : BillPaymentInfoVoFromJSON(json['paymentInfo']),
    };
}

export function BillDetailVoToJSON(json: any): BillDetailVo {
    return BillDetailVoToJSONTyped(json, false);
}

export function BillDetailVoToJSONTyped(value?: BillDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billType': value['billType'],
        'orderCode': value['orderCode'],
        'exchangeRate': value['exchangeRate'],
        'applyUnit': value['applyUnit'],
        'applyValue': value['applyValue'],
        'totalGoodsAmount': value['totalGoodsAmount'],
        'totalAdditionalServiceAmount': value['totalAdditionalServiceAmount'],
        'totalTransferAmount': value['totalTransferAmount'],
        'totalAmount': value['totalAmount'],
        'cardNumber': value['cardNumber'],
        'cardType': value['cardType'],
        'currencyCode': value['currencyCode'],
        'userId': value['userId'],
        'name': value['name'],
        'status': value['status'],
        'enable': value['enable'],
        'billCode': value['billCode'],
        'cardBankName': value['cardBankName'],
        'cardHolderName': value['cardHolderName'],
        'remark': value['remark'],
        'createStaffId': value['createStaffId'],
        'userBusinessType': value['userBusinessType'],
        'targetId': value['targetId'],
        'originalBill': BillDetailVoToJSON(value['originalBill']),
        'warehouseId': value['warehouseId'],
        'returnAmount': value['returnAmount'],
        'relatedBillCodes': value['relatedBillCodes'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'goodsList': value['goodsList'] == null ? undefined : ((value['goodsList'] as Array<any>).map(BillDetailGoodsVoToJSON)),
        'additionalServiceList': value['additionalServiceList'] == null ? undefined : ((value['additionalServiceList'] as Array<any>).map(BillDetailAdditionalServiceVoToJSON)),
        'commonList': value['commonList'] == null ? undefined : ((value['commonList'] as Array<any>).map(BillDetailCommonVoToJSON)),
        'paymentInfo': BillPaymentInfoVoToJSON(value['paymentInfo']),
    };
}

